module.exports = __webpack_public_path__ + "img/Open.62906119.svg";